import { Box, Flex } from '@chakra-ui/react'
import DsrPageSideMenu from '../components/DsrPageSideMenu'
import DisplayNewsFeedPublic from '../dsr-content-components/DisplayNewsFeedPublic'

import { memo, useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { logGuestDsrAnalytics } from '../../analytics/actions/dsr-analytics-actions'
import { bindActionCreators } from 'redux'
import RenderSubpageContent from '../components/RenderSubpageContent'
import '../../layout/components/layout/styles/dsr-content.scss'
import DsrDynamicModal from '../messages/DsrDynamicModal'
import EmbeddedZoomMeetingDisplay from '../dsr-zoom/EmbeddedZoomMeetingDisplay'
import useLaunchdeckModal from '../../global/hooks/use-launchdeck-modal'
import { manageDsrUrlTags } from '../../global/helpers/url-tag-helpers'
import useChangeSubpageDisplay from '../../global/hooks/change-subpage-display';

const RenderPreviewDsrContent = ({
  dsrId,
  dsrTitle,
  selectedDisplaySubpage,
  selectedDisplayPageId,
  userActionRequiredState,
  showDsrModalState,
  pagesLocalState,

  // Redux states
  dsrPropertiesRedux,
  dsrTeamMembersRedux,
  dsrFeedContent,
  dsrActionList,

  overviewPageId
}) => {

  const { openLaunchdeckModal, closeLaunchdeckModal } = useLaunchdeckModal();
  const { handleSelectSubpage } = useChangeSubpageDisplay();

  const [localState, setLocalState] = useState({
    showDsrModalLoader: false,
    showConfirmationModal: false,
    confirmationType: '',
    replyIdToEdit: '',
    userIdToken: '',
    modalTransferPayload: '',
    postTagProperties: []
  })

  const handleChangeUserActionRequired = (newUserActionRequired, modalTransferPayload) => {
    openLaunchdeckModal(newUserActionRequired)
    
    setLocalState((prevState) => ({
      ...prevState,
      modalTransferPayload,
    }))
  }


  const handleDsrModalClose = () => {
    closeLaunchdeckModal()
  }


  const handleOpenPagePreviewMessageModal = () => {
    openLaunchdeckModal("show-preview-page-action-modal")
  }

  useEffect(() => {
    const handleUrlChange = () => {
      const viewpage = manageDsrUrlTags("viewpage");

      switch(viewpage) {
        case('overview'): {
         // Overview page is called with pageId
          overviewPageId && handleSelectSubpage(overviewPageId,"")
          break;
        }
        case('updates'): {
          handleSelectSubpage("","updates-subpage")
          break;
        }
        case('faq'): {
          handleSelectSubpage("","faq-subpage")
          break;
        }
        case('map'): {
          handleSelectSubpage("","action-list-subpage")
          break;
        }
        case('shared-docs'): {
          handleSelectSubpage("","shared-docs-folder-subpage")
          break;
        }
        default: {
          viewpage && handleSelectSubpage("pg__" + viewpage,"")
          break;
        }
      }
    };

    window.addEventListener("url-changed", handleUrlChange);

    return () => {
      window.removeEventListener("url-changed", handleUrlChange);
    };
  }, [pagesLocalState]);

  
  return (
    <Flex className='dsr-content__section'>
      <Flex className='dsr-content__container'>
        <Flex direction="column" align="flex-start" w='100%' minHeight="40em">
          <Flex direction="row" align="flex-start" width="100%" height='100%'>
            <Flex bg="white" position='sticky' top='140px'>
              <DsrPageSideMenu
                pageArray={pagesLocalState}
                selectedDisplayPageId={selectedDisplayPageId}
                handleSelectSubpage={handleSelectSubpage}
                headerMenuHeight="140px"
                isPagePreviewMode={true}
                altPageNames={dsrPropertiesRedux.altPageNames}
              />
            </Flex>
            <Flex
              direction={['column', 'row']}
              justify="center"
              flexWrap="wrap"
              width="100%"
              bg='#F4F4F4'
              height='100%'
            >
              <Box mt={'2em'} w="100%" px="3em" maxWidth='900px' pb='3em'>
                {selectedDisplaySubpage === 'updates-subpage' &&
                  <DisplayNewsFeedPublic
                    dsrId={dsrId}
                    dsrTitle={dsrTitle}
                    displayedPostContent={dsrFeedContent}
                    dsrTeamMembers={dsrTeamMembersRedux}
                    showDsrModal={showDsrModalState}
                    showDsrModalLoader={localState.showDsrModalLoader}
                    modalTransferPayload={localState.modalTransferPayload}
                    handleChangeUserActionRequired={handleChangeUserActionRequired}
                    handleDsrModalClose={handleDsrModalClose}
                    handleSelectSubpage={handleSelectSubpage}
                    handleOpenSignupOrLoginModal={handleOpenPagePreviewMessageModal}
                  />
                }

                {/* Dev Note: This component is to display static public content, sharing RenderSubpageContent with the normal DSR display */}
                <RenderSubpageContent
                  pageArray={pagesLocalState}
                  selectedDisplaySubpage={selectedDisplaySubpage}
                  selectedDisplayPageId={selectedDisplayPageId}
                  dsrTeamMembers={dsrTeamMembersRedux}
                  isPagePreviewMode={true}

                  dsrId={dsrId}
                  dsrActionList={dsrActionList? dsrActionList : []}
                  dsrProperties={dsrPropertiesRedux}
                  handleOpenSignupOrLoginModal={handleOpenPagePreviewMessageModal}
                  handleSelectSubpage={handleSelectSubpage}
                />
                <EmbeddedZoomMeetingDisplay />   
              </Box>
            </Flex>

            <DsrDynamicModal
              dsrId = {dsrId}
              userActionRequired={userActionRequiredState}
              showDsrModal={showDsrModalState}
              showDsrModalLoader={localState.showDsrModalLoader}
              handleDsrModalClose={handleDsrModalClose}
              postTagProperties={localState.postTagProperties}
              handleChangeUserActionRequired={handleChangeUserActionRequired}
              modalTransferPayload={localState.modalTransferPayload}
            />

          </Flex>
        </Flex>
      </Flex>
    </Flex>
  )

}

const mapStateToProps = (state) => {
  return {
    dsrFeedContent: state.dsrFeedContent.results,
    userActionRequiredState: state.dsrPopup.UserActionRequired,
    showDsrModalState: state.dsrModal.showDsrModal,
    selectedDisplaySubpage: state.changeDsrPage.selectedDisplaySubpage,
    selectedDisplayPageId: state.changeDsrPage.selectedDisplayPageId,
    dsrPagesRedux: state.setDsrPages.pages,
    dsrPropertiesRedux: state.draftDsrProperties.properties,
    dsrTeamMembersRedux: state.dsrTeamMembers.members,
    dsrUserTeam: state.dsrUserTeam.userTeam,
    dsrActionList: state.dsrActionList.results.data,

  	overviewPageId: state.overviewPageId.id,
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logGuestDsrAnalytics,
    },
    dispatch,
  )

export default memo(withRouter(connect(mapStateToProps, mapDispatchToProps)(RenderPreviewDsrContent)))
